import { render, staticRenderFns } from "./TabModeratorThemeGalleryAwardDrawing.vue?vue&type=template&id=f73469d8&"
import script from "./TabModeratorThemeGalleryAwardDrawing.vue?vue&type=script&lang=js&"
export * from "./TabModeratorThemeGalleryAwardDrawing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
